import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=329baafe&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=329baafe&prod&scoped=true&lang=css&external"
import style1 from "./ChatList.vue?vue&type=style&index=1&id=329baafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329baafe",
  null
  
)

export default component.exports